import { Accordion, Link, LinkList } from '@postenbring/hedwig-react'

export const MenuMainContent = ({ mainContent }) => {
    const menuMainContent = mainContent.map((section) => (
        <div key={section.heading}>
            <h2 className='hds-mb-12-16'>{section.heading}</h2>
            <LinkList>
                {section.items.map((item) => (
                    <li key={item.title + item.url}>
                        <Link
                            variant='no-underline'
                            key={item.title}
                            href={item.url}
                        >
                            {item.title}
                        </Link>
                    </li>
                ))}
            </LinkList>
        </div>
    ))

    const accordionItems = mainContent.map((section) => (
        <Accordion.Item
            key={section.heading}
            className='kp-menu-content-accordion-item'
        >
            <Accordion.Header>{section.heading}</Accordion.Header>
            <Accordion.Content>
                <LinkList>
                    {section.items.map((item) => (
                        <li key={item.title + item.url}>
                            <Link
                                variant='no-underline'
                                key={item.title}
                                href={item.url}
                            >
                                {item.title}
                            </Link>
                        </li>
                    ))}
                </LinkList>
            </Accordion.Content>
        </Accordion.Item>
    ))

    return (
        <>
            <div className='kp-menu-content-links kp-hidden-before-large'>
                {menuMainContent}
            </div>
            <Accordion className='kp-hidden-after-large'>
                {accordionItems}
            </Accordion>
        </>
    )
}
